import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/components/layout/Layout'

import { Login } from '@/components/login'
import { Properties } from '@/components/properties'
import { RulesIndex, Rules, RulesFields, RulesRulesets } from '@/components/rules'
import { Bindings } from '@/components/bindings'
import { Lists } from '@/components/lists'
import { Dashboard } from '@/components/dashboard'

export default createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			component: Layout,
			children: [
				{
					path: 'graph/:filter?/:value?/',
					name: 'Graph',
					component: () => import(/* webpackChunkName: "graph" */ '@/components/graph/Graph'),
					meta: { requiresAuth: true },
					props: true
				},
				{
					path: '',
					name: 'Monitoring',
					component: () => import(/* webpackChunkName: "monitoring" */ '@/components/monitoring/Monitoring'),
					alias: 'monitoring',
					meta: { requiresAuth: true }
				},
				{
					path: 'parameters',
					name: 'Parameters',
					component: Properties,
					meta: { requiresAuth: true }
				},
				{
					path: 'rules',
					component: RulesIndex,
					meta: { requiresAuth: true },
					children: [
						{
							path: '/rulesets',
							component: RulesRulesets,
							name: 'RulesRulesets',
							alias: ''
						},
						{
							path: 'edit',
							component: Rules,
							name: 'Rules'
						},
						{
							path: '/fields',
							component: RulesFields,
							name: 'RulesFields'
						}
					]
				},
				{
					path: 'bindings/edit',
					component: Bindings,
					name: 'BindingsEdit',
					meta: { requiresAuth: true }
				},
				{
					path: 'bindings',
					component: Bindings,
					name: 'BindingsIndex',
					meta: { requiresAuth: true }
				},
				{
					path: 'lists',
					component: Lists,
					name: 'Lists',
					meta: { requiresAuth: true }
				},
				{
					path: 'dashboard',
					component: Dashboard,
					name: 'Dashboard',
					meta: { requiresAuth: true }
				},
				{
					path: 'login',
					name: 'Login',
					component: Login,
					meta: { requiresRole: 'unauthorized', redirect: (to) => { return { path: to.query.redirect || '/' } } }
				}
			]
		}
	]
})
